import { Textarea } from "@mantine/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { PositionImage } from "../../interfaces";

type Props = {
  current: PositionImage;
};

const RenderApproveView: React.FC<Props> = ({ current }) => {
  const { t } = useTranslation();

  const handleSubmit = (e: any) => {
    e.preventDefault();
  };

  return (
    <div className="image-dont-approve">
      <h2 className="text-center">{t("printdataApproved")}</h2>

      <form
        style={{ pointerEvents: "none" }}
        onSubmit={handleSubmit}
        className="mt-30"
      >
        <Textarea
          mt={30}
          name="description"
          placeholder={t("noDescription")}
          defaultValue={current?.acceptedDescription}
          minRows={4}
        ></Textarea>
      </form>

      {current?.fullName && (
        <div className="grant-release mt-30">
          <span>{t("grantedReleaseText")}</span>
          <br />
          <span className="d-block mt-10">
            {t("fullName")}: {current.fullName}
          </span>
        </div>
      )}
    </div>
  );
};

export default RenderApproveView;
